import styled from 'styled-components';
const BaseSelectList = styled.ul `
  display: none;
  position: absolute;
  margin: 0;
  padding: 0;
  left: -1px;
  right: -1px;
  top: 45px;
  z-index: 1000;
  transition: box-shadow 0.3s ease;
  border: ${({ theme }) => `1px solid ${theme.colors.ui03}`};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.ui01};
  overflow: auto;
  box-shadow: ${({ theme }) => theme.shadows.medium};
  max-height: ${({ listHeight }) => listHeight || 'none'};

  overflow: auto;
  // for Firefox
  scrollbar-color: ${({ theme }) => theme.colors.text03} transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.text03};
  }

  &.visible {
    display: block;
  }
`;
export default BaseSelectList;
//# sourceMappingURL=BaseInputSelectList.js.map